// extracted by mini-css-extract-plugin
export default {"footer":"FuwgFooter_footer__mCuIV","text":"FuwgFooter_text__f1zoN"};